const blockSettori = () => {
    const btns = document.querySelectorAll('.block-settori__btn-more');
    if (!btns.length) return;

    btns.forEach(btn => {
        btn.addEventListener('click', () => {
            const grid = btn.closest('.block-settori').querySelector('.block-settori__grid');
            grid.querySelectorAll('.block-settori__col--hidden').forEach(el => {
                el.classList.remove('block-settori__col--hidden');
            });
            btn.closest('.block-settori__load-more').remove();
        });
    });
};

export default blockSettori;
